import { render, staticRenderFns } from "./ARegistrationOptions.vue?vue&type=template&id=658f60d3&"
import script from "./ARegistrationOptions.vue?vue&type=script&lang=js&"
export * from "./ARegistrationOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports